import type { AiAnalyzingBorderMode } from '../../AiAnalyzingBorder';

interface AiBorderModeInput {
  isAnalyzing: boolean;
  isDeciding: boolean;
  isRecommendedCard: boolean;
  isPremiumPlanVariant: boolean;
}

export const getAiBorderMode = ({
  isAnalyzing,
  isDeciding,
  isRecommendedCard,
  isPremiumPlanVariant,
}: AiBorderModeInput): AiAnalyzingBorderMode => {
  if (isDeciding) {
    if (isRecommendedCard) {
      return 'grow';
    }
    return isPremiumPlanVariant ? 'fade' : 'off';
  }
  return isAnalyzing ? 'travel' : 'off';
};
